export const cweKeys = {
  all: ["cwe"] as const,
  file: (cweFile: string) => [...cweKeys.all, "file", cweFile] as const,
};
export const csvKeys = {
  all: ["csv"] as const,
  file: (csvFile: string) => [...cweKeys.all, "file", csvFile] as const,
};
